// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleTitle_root__1SxDD","feature":"ArticleTitle_feature__dnLOA"};